var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zheshang-screen-root"},[_c('iframe',{staticClass:"screen-iframe",attrs:{"src":_vm.iframeSrc,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }